import { useForm } from '@mantine/form';
import { useState } from 'react';
import type { UpsertDepartmentDto } from '../types/DepartmentDto';
import {
	validateNumber,
	validateText,
} from '../../../util/validation/commonValidation';

const defaultDepartment: UpsertDepartmentDto = {
	id: '',
	departmentName: '',
	groupId: '',
	shouldDisplay: '',
};

export function useUpsertDepartmentForm(
	department: UpsertDepartmentDto = defaultDepartment,
) {
	const [inputs, setInputs] = useState<UpsertDepartmentDto>(department);

	const form = useForm<UpsertDepartmentDto>({
		mode: 'uncontrolled',
		initialValues: department,
		validate: {
			departmentName: (value) => validateText(value, false, 'Name', 50),
			groupId: (value) => validateNumber(value, false, 0, 1000000, 'Group'),
			shouldDisplay: (value) => {
				if (value.length < 1) return 'Please select display value';
			},
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
